var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDropDown = function SvgArrowDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-drop-down_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-drop-down_svg__arrow-drop-down"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.71 11.71 2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71",
    className: "arrow-drop-down_svg__vector"
  }))));
};
export { SvgArrowDropDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5BcnJvdyBEcm9wIERvd248L3RpdGxlPjxnIGNsYXNzPSJhcnJvdy1kcm9wLWRvd24iPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0ibTguNzEgMTEuNzEgMi41OSAyLjU5Yy4zOS4zOSAxLjAyLjM5IDEuNDEgMGwyLjU5LTIuNTljLjYzLS42My4xOC0xLjcxLS43MS0xLjcxSDkuNDFjLS44OSAwLTEuMzMgMS4wOC0uNyAxLjcxWiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";